export default "__VITE_ASSET__0$1M3ZUg__"